import createPersistedState from 'vuex-persistedstate';
import * as Cookies from 'js-cookie';

const cookieStorage = {
  getItem: key => Cookies.get(key),
  // Please see https://github.com/js-cookie/js-cookie#json, on how to handle JSON.
  setItem: (key, value) => Cookies.set(key, value, { expires: 30, secure: process.env.NODE_ENV === 'production' }),
  removeItem: key => Cookies.remove(key),
};

const defaultConfig = {
  reducer(state) {
    return {
      appointmentTypes: state.appointmentTypes,
      business: state.business,
    };
  },
};

const cookieConfig = {
  key: '_vuex',
  reducer(state) {
    return {
      auth: state.auth,
    };
  },
  storage: cookieStorage,
};

const persistedCookieState = createPersistedState(cookieConfig);
const persistedState = createPersistedState(defaultConfig);

export { persistedCookieState, persistedState };



// WEBPACK FOOTER //
// ./src/store/persistedState.js